// extracted by mini-css-extract-plugin
export default {"wrapper":"ticketLink_wrapper__G6+Cx","text":"ticketLink_text__zDBDb","icon":"ticketLink_icon__aJcsz"};